import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

ReactGA.initialize("G-Z7CCY9SRTG"); // Injects Google Tag Manager code
ReactDOM.createRoot(document.getElementById("root")).render(<App />);
